import { useCallback } from 'react';
import { authenticatedFetch } from '../../../utils/api';

const parseDeviceInfo = (info) => {
    if (!info) return { browser: '', browserVersion: '', os: '' };
    const browserMatch = info.match(/browser\.name = ([^,]+), browser\.version = ([^,]+)/);
    const osMatch = info.match(/os\.name = ([^,]+), os\.version = ([^,]+)/);
    return {
        browser: browserMatch ? browserMatch[1] : '',
        browserVersion: browserMatch ? browserMatch[2] : '',
        os: osMatch ? `${osMatch[1]} ${osMatch[2]}` : ''
    };
};

const useFeatureAccess = ({ deviceInfo }) => {
    const logFeatureAccess = useCallback((feature, metadata = null) => {
        const parsedDevice = parseDeviceInfo(deviceInfo);

        authenticatedFetch('/ManagerReport/LogFeatureAccess', {
            method: 'POST',
            body: JSON.stringify({
                Feature: feature,
                Metadata: metadata,
                BrowserVersion: parsedDevice.browserVersion,
                OS: parsedDevice.os
            })
        }).catch(() => {});
    }, [deviceInfo]);

    return { logFeatureAccess };
};

export default useFeatureAccess;
